export default function() {
  var root = this, links = [];
  root.each(function(node) {
    if (node !== root) { // Don’t include the root’s parent, if any.
      links.push({source: node.parent, target: node});
    }
  });
  return links;
}



//////////////////
// WEBPACK FOOTER
// ./packages/layout/node_modules/d3-hierarchy/src/hierarchy/links.js
// module id = 308
// module chunks = 0